import { render, staticRenderFns } from "./PartnerDirectoryView.vue?vue&type=template&id=64763b34&scoped=true"
import script from "./PartnerDirectoryView.vue?vue&type=script&lang=js"
export * from "./PartnerDirectoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64763b34",
  null
  
)

export default component.exports